module.exports = __webpack_public_path__ + "img/credit-coins.4ea5ba0.svg";